<template>
    <div class="meeting-container">
       <div class="overlay" v-if="isOnPriva">
            <div>
                <p>
                主持人正在对当事人进行一对一视频私聊
                </p>
                <br>
                <p>
                    视频暂停，请您稍后
                </p>
                <br>
                <p>{{ptivateMytime}}</p>
            </div>
        </div>
        <div :class="[{insideopen: insideshow},'meeting-main']">
            <div class="meeting-header clearfix">
                <div class="meeting-class-title">
                    <div class="meetingexit"><div class="quit" @click="goHomeRouter"><i class="ico_quit"></i>离开视频</div></div>
                </div>
            </div>
            <div class="meeting-area-main">
                <div class="curmemberinfo">
                    <span class="memberinfo">
                        {{mainView.rolename}}：{{mainView.name}}
                        <i class="audio" v-if="!Boolean(requestingPushers[mainView.id] && requestingPushers[mainView.id].audio)"></i>
                        <i class="hand" v-if="handMap[mainView.id]"></i>
                    </span>
                    <i class="timing">{{mytime}}</i>
                </div>
                <div v-show="(onlineStatus[mainView.id]=='ONLINE')&&Boolean(requestingPushers[mainView.id])&&!Boolean(requestingPushers[mainView.id] && requestingPushers[mainView.id].video)" class="exitroom">{{mainView.name}} 关闭了视频</div>
                <div v-show="onlineStatus[mainView.id]=='OFFLINE'" class="exitroom">{{mainView.name}} 离开了视频会议</div>
                <div v-if="!Boolean(onlineStatus[mainView.id])" class="exitroom">等待进入视频会议</div>
                <video id="localVideo" class="mainvideo" autoplay playinline></video>
            </div>
            <div class="member-list-container">
                <div class="right_scroll" @click="memberListScroll(false)"></div>
                <div ref="meetingMemberList" class="meeting-member-list-inner">
                    <ul class="meeting-scroll" v-bind:style="'width:'+members.length*250+'px'">
                        <template v-for="(item, index) in members" v-if="!Boolean(pusherVideosDisplay[item.id])">
                            <li class="meeting-member-box" :key="index" v-if="(item.id != mainView.id) && item.id">
                                <div class="meeting-member-body">
                                    <div class="meeting-member-body-info">
                                        <div>
                                            <!-- <i v-if="item.id==userID" :class="[{on:isaudioopen},'icon_useraudio']"></i> -->
                                            <i :class="[{on:Boolean(requestingPushers[item.id] && requestingPushers[item.id].audio)},'icon_useraudio']"></i>
                                            <!-- <i v-if="item.id==userID" :class="[{on:isvideoopen},'icon_uservideo']"></i> -->
                                        </div>
                                    </div>
                                </div>
                                <!-- 互动人员图片 start -->
                                <div class="meeting-member-img" :id="'video_'+(item.id)">
                                    <div v-if="pusherVideosDisplay[item.id]" class="exitroom">{{item.name}} {{item.id!=privateUserId?'断开了视频连接':'正在私聊中'}}</div>
                                    <div v-if="!Boolean(requestingPushers[item.id] && requestingPushers[item.id].video)&&!Boolean(pusherVideosDisplay[item.id])" class="exitroom">{{item.name}} 视频被关闭</div>
                                    <video :id="'v_'+(item.id)" style=" margin-left: -50px; width:330px; height:190px;" autoplay playsinline></video>
                                </div>
                                <!-- 互动人员图片 end -->
                                <!-- 互动信息   要 start -->
                                <div class="meeting-member-foot">
                                    <!-- <i v-if="item.role=='APPLICANT'||item.role=='APPLICANT_AGENT'||item.role=='PETITION_AGENT'" class="icon_applicant"></i>
                                    <i v-else-if="item.role=='RESPONDENT'||item.role=='RESPONDENT_AGENT'" class="icon_respondent"></i>
                                    <i v-else-if="item.role=='MEDIATOR'" class="icon_meditor"></i> -->
                                    <span class="meeting-member-name">{{allmembertype[item.role]}}:{{item.name}}</span>
                                </div>
                            </li>
                        </template>
                    </ul>
                </div>
                <div class="left_scroll" @click="memberListScroll(true)"></div>
            </div>
        </div>
        <!-- <div :class="[{insideopen: insideshow}, 'meeting-inside']">
            <div class="inside_button">
                <div v-if="!insideshow" class="inside_menu ico_btn_a" @click="openinside('first')">沟通记录</div>
                <div v-if="!insideshow" class="inside_menu ico_btn_b" @click="openinside('second')">案件材料</div>
                <div v-if="!insideshow" class="inside_menu ico_btn_c" @click="openinside('third')">工作区</div>
                <div v-if="insideshow" class="inside_menu_close" @click="openinside('first')">收起</div>
            </div>
            <inside v-show="insideshow" ref="inside" v-model="comdata" :wselement="ws" @comcallback="changStatushNotice" :meetingId="meetingId" :singleCaseId="singleCaseId" @sourceMessage="setSource"></inside>
        </div> -->
        <privatechat ref="privatechat" v-model = "comdata" :wselement="ws" :socketStatus="socketStatus" :members="member_list" @comcallback="changStatushMessage" @sourceMessage="setSource"></privatechat>
    </div>
</template>
<script>
import axios from 'axios'
import inside from '../components/inside.vue'
import privatechat from '../components/privatechat.vue'
import {setStore,getStore,removeStore} from '@/utils/utils.js'
import {getMediationInfo} from '@/api/meeting'
import meetingMixins from '../assets/js/meetingMixins.js'
export default {
    mixins: [meetingMixins],
    components: {
        'inside':inside,
        'privatechat':privatechat
    },
    data(){
        return {
            // singleCaseId:0,
            // meetingId:0,
        }
    },
    created() {
        let query = this.$route.query, self = this;
        // this.singleCaseId = this.$route.query.caseid
        // this.meetingId = this.$route.query.meetingid
        if (!Boolean(query.token)) {
            self.$alert('<h4 class="title_normal">温馨提示</h4><div>用户未登录</div>', '温馨提示', {
                dangerouslyUseHTMLString: true,
                confirmButtonText: '确定',
                confirmButtonClass: 'meeting_button_primary_small',
                customClass: 'alert_quit'
            }).then(() => {
                document.location.href= '/login'
            });
            return;
        } else {
            self.userID = null
            self.canDraw = true;
            self.selfName = '观摩人'
            self.iswatcher = true
            self.ismediator = false
            self.istemporary = false
            self.ispusher = true
            self.roomID = self.$route.query.roomid
            self.caseID = self.$route.query.caseid
            self.meetingID = self.$route.query.meetingid
            self.comdata = {
                'caseID': self.$route.query.caseid,
                'roomID': self.$route.query.roomid,
                'meetingID': self.$route.query.meetingid,
                'userID': null,
                'selfName': '观摩人',
                'iswatcher': true,
                'ispusher': true, //区分有无画面（有画面观摩人，无画面观摩人）
                'istemporary': false,
                'mediatorself': false,
                'roleType': null
            }
            self.userToken = self.$route.query.token
        }
        self.webRtcInit()
    },
}
</script>
<style lang="scss">
    @import '../assets/css/meetingCss.scss';
    .overlay{
        width: 100%;
        height: 100%;
        top:0px;left:0px;
        z-index:1001;
        background-color:#000;
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: center;
        color:#fff;
        font-size:26px;
        position: fixed;
    }
</style>
